import { dateTransform, getCouponBadgeStatus } from "helpers/dataHelpers";

import { CancelIcon, CheckCircleIcon } from "icons";
import {
  Coupon,
  CouponAllowedUser,
  CouponType,
  CouponTypeLabel,
  DiscountType,
  DiscountTypeLabel,
} from "types/coupons";
import { theme } from "theme";
import { Badge } from "components";

import { FlexContainer } from "styled/Box";
import { getCouponDiscountLabel } from "pages/Coupons/helpers";

export const columns = [
  {
    title: "Coupon code",
    dataIndex: "couponCode",
    key: "couponCode",
  },
  {
    title: "Discount Type",
    dataIndex: "discountType",
    key: "discountType",
    render: (value: DiscountType) => DiscountTypeLabel[value] || value,
  },
  {
    title: "Discount",
    dataIndex: "discountOff",
    key: "discountOff",
    align: "right" as const,
    render: (value: number, record: Coupon) =>
      getCouponDiscountLabel(value, record),
  },
  {
    title: "Number Of Uses (per user)",
    dataIndex: "numberOfUses",
    key: "numberOfUses",
    align: "center" as const,
    width: 300,
  },
  {
    title: "Count Of Uses",
    dataIndex: "couponUsageCount",
    key: "couponUsageCount",
    align: "center" as const,
  },
  {
    title: "Allowed users",
    dataIndex: "allowedUsers",
    key: "allowedUsers",
    align: "center" as const,
    render: (users: CouponAllowedUser[]) => users?.length || "All",
  },
  {
    title: "Coupon Type",
    dataIndex: "couponType",
    key: "couponType",
    align: "center" as const,
    render: (couponType: CouponType) => (
      <Badge title={CouponTypeLabel[couponType] || couponType} />
    ),
  },
  {
    title: "Active",
    dataIndex: "isActive",
    key: "isActive",
    align: "center" as const,
    render: (isActive: boolean) => (
      <FlexContainer $justify="center">
        {isActive ? (
          <CheckCircleIcon />
        ) : (
          <CancelIcon fill={theme.color.error} />
        )}
      </FlexContainer>
    ),
  },
  {
    title: "Multiple usage",
    dataIndex: "allowMultipleUsage",
    key: "allowMultipleUsage",
    align: "center" as const,
    render: (isActive: boolean) => (
      <FlexContainer $justify="center">
        {isActive ? (
          <CheckCircleIcon />
        ) : (
          <CancelIcon fill={theme.color.error} />
        )}
      </FlexContainer>
    ),
  },
  {
    title: "Status",
    dataIndex: "startDate",
    key: "startDate",
    align: "center" as const,
    render: (startDate: string, record: Coupon) => {
      const { title, bgColor, textColor } = getCouponBadgeStatus(
        startDate,
        record.expiryDate,
      );
      return <Badge title={title} bgColor={bgColor} textColor={textColor} />;
    },
  },

  {
    title: "Start date",
    dataIndex: "startDate",
    key: "startDate",
    render: (date: string) =>
      dateTransform({
        date,
      }),
  },
  {
    title: "Expire date",
    dataIndex: "expiryDate",
    key: "expiryDate",
    render: (date: string) =>
      dateTransform({
        date,
      }),
  },
  {
    title: "Updated at",
    dataIndex: "updatedAt",
    key: "updatedAt",
    render: (date: string) =>
      dateTransform({
        date,
      }),
  },
  {
    title: "Created at",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (date: string) =>
      dateTransform({
        date,
      }),
  },
];
